import { CONFIG } from '../config';
import { Gender } from '../constants/gender';

export type User = {
  email: string | null;
  gender: Gender;
};

export type RespError = {
  code: string;
  detail?: string;
  message?: string;
};

type Params = {
  user?: User;
  onSuccess: () => void;
  onFail: (err: RespError) => void;
  placement?: string;
};

export const setNewsletterPreference = ({
  user,
  onSuccess,
  onFail,
  placement = 'footer'
}: Params) => {
  return fetch(`${CONFIG.MODA_API_URL}/v3.3/users/set_email_newsletter_preferences`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    body: JSON.stringify({
      user,
      placement
    })
  })
    .then(response => response.json())
    .then(() => {
      onSuccess();
    })
    .catch(error => {
      onFail(error);
    });
};
